var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.to ? 'nuxt-link' : 'a',_vm._b({tag:"component",class:[
        ("btn btn-" + _vm.variant + " btn-" + _vm.size),
        { 'btn-block': _vm.block, 'btn-icon': _vm.btnIcon } ]},'component',{ to: _vm.to, href: _vm.href, target: _vm.target },false),[(_vm.$slots['icon:before'])?_c('span',{staticClass:"d-inline-block mr-3"},[_vm._t("icon:before")],2):_vm._e(),_vm._v(" "),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }